import { getAllEvents } from "./Firestore";

// Booker and FindSomeoneSpotlight each independently run the exact same "every event from the
// last 730 days" query (getAllEvents(companyId) with no explicit cutoffDate) whenever both load
// on the same page view - opening the spotlight while Booker is already on screen otherwise means
// a second full multi-year query for data the first one just fetched. Only caches that default,
// no-cutoffDate query - callers that pass a narrower cutoffDate (e.g. Dashboard's "who's in
// today") want a genuinely different, smaller query and go straight to getAllEvents untouched.
const CACHE_TTL_MS = 15_000;
const cache = new Map(); // companyId -> { expiresAt, promise }

export function getAllEventsCached(companyId) {
  const now = Date.now();
  const cached = cache.get(companyId);
  if (cached && cached.expiresAt > now) {
    return cached.promise;
  }

  const promise = getAllEvents(companyId).catch((err) => {
    // Don't leave a rejected promise cached for the rest of the TTL - the next caller gets a
    // fresh attempt instead of the same failure replayed at them.
    if (cache.get(companyId)?.promise === promise) cache.delete(companyId);
    throw err;
  });

  cache.set(companyId, { expiresAt: now + CACHE_TTL_MS, promise });
  return promise;
}

// Called after any booking mutation (create/edit/cancel/delete) so the very next read - Booker's
// own reloadEvents() - gets genuinely fresh data instead of a stale cached copy, and so
// FindSomeoneSpotlight doesn't keep showing a booking that was just changed in the same session.
export function invalidateEventsCache(companyId) {
  cache.delete(companyId);
}
